var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('p',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('request-form-text'))))]),_c('ticket-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }